import {
  Box,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import { useLocalPrefs } from "../../utils/localPrefs";

const WINDOWS = [
  { hours: 6, label: "6 hours" },
  { hours: 12, label: "12 hours" },
  { hours: 24, label: "24 hours" },
  { hours: 48, label: "48 hours" },
  { hours: 72, label: "3 days" },
];

/** Per-browser preferences. These are stored locally and don't affect other users. */
const GeneralTab = () => {
  const [prefs, setPrefs] = useLocalPrefs();

  return (
    <Box>
      <Typography variant="h4" fontWeight="bold" mb={0.5}>
        General
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={3}>
        These settings are saved on this device only.
      </Typography>

      <Paper sx={{ p: 3, maxWidth: 640 }}>
        <Typography variant="h5" fontWeight="bold" mb={1}>
          Covers
        </Typography>
        <Stack gap={2}>
          <FormControlLabel
            control={
              <Switch
                checked={prefs.coversShowNew}
                onChange={(e) => setPrefs({ coversShowNew: e.target.checked })}
                inputProps={{ "aria-label": "Show new section on Covers page" }}
              />
            }
            label={
              <Box>
                <Typography>Show a "New" section at the top of the Covers page</Typography>
                <Typography variant="body2" color="text.secondary">
                  Lists sessions that were recently marked Unconfirmed so they stand out.
                </Typography>
              </Box>
            }
          />
          <FormControl size="small" sx={{ maxWidth: 240 }} disabled={!prefs.coversShowNew}>
            <InputLabel id="covers-new-window">Treat as new for</InputLabel>
            <Select
              labelId="covers-new-window"
              label="Treat as new for"
              value={prefs.coversNewHours}
              onChange={(e) => setPrefs({ coversNewHours: Number(e.target.value) })}
            >
              {WINDOWS.map((w) => (
                <MenuItem key={w.hours} value={w.hours}>
                  {w.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </Paper>
    </Box>
  );
};

export default GeneralTab;
